var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Prop, Watch } from "vue-facing-decorator";
import { ReportClient, PersonsClient, ContactGroupClient, GetPersonListQuery, GetContactGroupListQuery } from "@/app/api/battery-portal-api";
const reportClient = new ReportClient(window.apiUrl);
const personsClient = new PersonsClient(window.apiUrl);
const contactGroupsClient = new ContactGroupClient(window.apiUrl);
let ContactsVue = class ContactsVue extends Vue {
    constructor() {
        super(...arguments);
        this.filterOnlyContactsWithEmail = false;
        this.isReport = false;
        this.contactIds = [];
        this.contactGroupIds = [];
        this.contacts = new Array();
        this.contactGroups = [];
        this.contactsFilter = "";
        this.contactGroupsFilter = "";
        this.showOnlySelected = false;
        this.showOnlyGroupsSelected = false;
        this.activeTab = 0;
        this.loadingContacts = false;
        this.isUserAllowedToScheduleReportsToOtherUsers = true;
        this.loadedCompanyId = null;
    }
    created() {
        this.getContacts();
    }
    getContacts() {
        this.loadingContacts = true;
        let promises = [];
        if (this.isReport) {
            promises.push(reportClient
                .getContactListForScheduledReport(this.companyId));
        }
        else {
            promises.push(personsClient
                .getListPOST(new GetPersonListQuery({ companyId: this.companyId, includeDeleted: false, keywords: "" })));
        }
        promises.push(contactGroupsClient
            .getListPOST(new GetContactGroupListQuery({ companyId: this.companyId, includeDeleted: false, keywords: "" })));
        Promise.all(promises)
            .then((values) => {
            var _a, _b, _c;
            try {
                if ((_a = values[0]) === null || _a === void 0 ? void 0 : _a.contacts) {
                    this.contacts = values[0].contacts;
                    this.isUserAllowedToScheduleReportsToOtherUsers = values[0].isUserAllowedToScheduleReportsToOtherUsers;
                    if (this.isUserAllowedToScheduleReportsToOtherUsers === false) {
                        this.contactIds.splice(0, this.contactIds.length);
                        var firstContact = this.contacts[0];
                        if (firstContact.emailAddress)
                            this.contactIds.push(this.contacts[0].personId);
                    }
                }
                else
                    this.contacts = values[0];
                this.contactGroups = values[1];
                this.loadedCompanyId = this.companyId;
                if (((_b = this.contactIds) === null || _b === void 0 ? void 0 : _b.length) > 0)
                    this.removeContactIdsNotPresentInTheList();
                if (((_c = this.contactGroupIds) === null || _c === void 0 ? void 0 : _c.length) > 0)
                    this.removeContactGroupIdsNotPresentInTheList();
                this.loadingContacts = false;
            }
            catch (e) {
                console.error(e);
            }
        });
    }
    onCompanyIdChanged() {
        this.getContacts();
    }
    onContactIdsChanged() {
        var _a;
        if (this.loadedCompanyId !== this.companyId) {
            return;
        }
        if (((_a = this.contactIds) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.contacts.length > 0)
            this.removeContactIdsNotPresentInTheList();
    }
    onContactGroupIdsChanged() {
        var _a;
        if (this.loadedCompanyId !== this.companyId) {
            return;
        }
        if (((_a = this.contactGroupIds) === null || _a === void 0 ? void 0 : _a.length) > 0 && this.contactGroups.length > 0)
            this.removeContactGroupIdsNotPresentInTheList();
    }
    // Contacts
    get contactsFiltered() {
        var strFilter = this.contactsFilter.toLowerCase();
        return this.contacts
            .filter(item => {
            var _a;
            if (this.filterOnlyContactsWithEmail && !item.emailAddress)
                return false;
            const fullName = `${item.firstName || ''} ${item.lastName || ''}`.toLowerCase();
            return fullName.includes(strFilter) || ((_a = item.emailAddress) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(strFilter));
        })
            .filter(item => !this.showOnlySelected || this.isContactSelected(item));
    }
    isContactSelected(item) {
        try {
            return this.contactIds != null && this.contactIds.includes(item.personId);
        }
        catch (ex) {
            console.error(ex);
        }
        return false;
    }
    selectContact(item) {
        if (!this.contactIds || this.isUserAllowedToScheduleReportsToOtherUsers === false)
            return;
        var idx = this.contactIds.indexOf(item.personId);
        if (idx >= 0)
            this.contactIds.splice(idx, 1);
        else
            this.contactIds.push(item.personId);
    }
    selectedContactCount() {
        var _a, _b, _c, _d;
        var count = (_b = (_a = this.contactIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        this.showOnlySelected = count == 0 ? false : this.showOnlySelected;
        return (_d = (_c = this.contactIds) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    }
    removeContactIdsNotPresentInTheList() {
        var idxToRemove = [];
        this.contactIds.forEach((id, idx) => {
            if (!this.contacts.find(item => item.personId == id))
                idxToRemove.push(idx);
        });
        idxToRemove.forEach(idx => this.contactIds.splice(idx, 1));
    }
    // Contact Groups
    get contactGroupsFiltered() {
        var strFilter = this.contactGroupsFilter.toLowerCase();
        return this.contactGroups
            .filter(item => { var _a; return (_a = item.description) === null || _a === void 0 ? void 0 : _a.toLowerCase().includes(strFilter); })
            .filter(item => !this.showOnlyGroupsSelected || this.isContactGroupSelected(item));
    }
    isContactGroupSelected(item) {
        try {
            return this.contactGroupIds != null && this.contactGroupIds.includes(item.contactGroupId);
        }
        catch (ex) {
            console.error(ex);
        }
        return false;
    }
    selectContactGroup(item) {
        if (!this.contactGroupIds)
            return;
        var idx = this.contactGroupIds.indexOf(item.contactGroupId);
        if (idx >= 0)
            this.contactGroupIds.splice(idx, 1);
        else
            this.contactGroupIds.push(item.contactGroupId);
    }
    selectedContactGroupCount() {
        var _a, _b, _c, _d;
        var count = (_b = (_a = this.contactGroupIds) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0;
        this.showOnlyGroupsSelected = count == 0 ? false : this.showOnlyGroupsSelected;
        return (_d = (_c = this.contactGroupIds) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0;
    }
    removeContactGroupIdsNotPresentInTheList() {
        var idxToRemove = [];
        this.contactGroupIds.forEach((id, idx) => {
            if (!this.contactGroups.find(item => item.contactGroupId == id))
                idxToRemove.push(idx);
        });
        idxToRemove.forEach(idx => this.contactGroupIds.splice(idx, 1));
    }
    getContactNames(item) {
        if (!(item === null || item === void 0 ? void 0 : item.persons))
            return "";
        return item.persons
            .map(contact => `${contact.firstName} ${contact.lastName}`)
            .sort((a, b) => {
            if (a < b)
                return -1;
            if (a > b)
                return 1;
            return 0;
        })
            .join(', ');
    }
};
__decorate([
    Prop(),
    __metadata("design:type", Object)
], ContactsVue.prototype, "companyId", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], ContactsVue.prototype, "filterOnlyContactsWithEmail", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Boolean)
], ContactsVue.prototype, "isReport", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], ContactsVue.prototype, "contactIds", void 0);
__decorate([
    Prop(),
    __metadata("design:type", Array)
], ContactsVue.prototype, "contactGroupIds", void 0);
__decorate([
    (Watch("companyId")),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactsVue.prototype, "onCompanyIdChanged", null);
__decorate([
    Watch("contactIds"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactsVue.prototype, "onContactIdsChanged", null);
__decorate([
    Watch("contactGroupIds"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], ContactsVue.prototype, "onContactGroupIdsChanged", null);
ContactsVue = __decorate([
    Component({
        name: "ContactsVue",
    })
], ContactsVue);
export default ContactsVue;
